<template>
  <div class="integration-functions-diff-table-component">
    <table class="table">
      <tbody>
      <tr>
        <td>
          <font-awesome-icon
              icon="fa-regular fa-check-circle"
              color="green"
              size="1half-x"
          />
        </td>
        <td class="is-flex is-justify-content-start is-align-content-center">
          <span><strong>Chat</strong></span>
        </td>
      </tr>
      <tr>
        <td>
          <font-awesome-icon
              icon="fa-regular fa-check-circle"
              color="green"
              size="1half-x"
          />
        </td>
        <td class="is-flex is-justify-content-start is-align-content-center">
          <span><strong>Dados e Métricas</strong></span>
        </td>
      </tr>
      <tr>
        <td>
          <font-awesome-icon
              icon="fa-regular fa-check-circle"
              color="green"
              size="1half-x"
          />
        </td>
        <td class="is-flex is-justify-content-start is-align-content-center">
          <span><strong>Campanhas</strong></span>
        </td>
      </tr>
      <tr>
        <td>
          <font-awesome-icon
              icon="fa-regular fa-check-circle"
              color="green"
              size="1half-x"
          />
        </td>
        <td class="is-flex is-justify-content-start is-align-content-center">
          <span><strong>CRM</strong></span>
        </td>
      </tr>
      <tr>
        <td>
          <font-awesome-icon
              icon="fa-regular fa-check-circle"
              color="green"
              size="1half-x"
          />
        </td>
        <td class="is-flex is-justify-content-start is-align-content-center">
          <span><strong>Bot de Conversa</strong></span>
        </td>
      </tr>
      <tr>
        <td>
          <font-awesome-icon
              icon="fa-regular fa-check-circle"
              color="green"
              size="1half-x"
          />
        </td>
        <td class="is-flex is-justify-content-start is-align-content-center">
          <span><strong>Público Alvo</strong></span>
        </td>
      </tr>
      <tr>
        <td>
          <font-awesome-icon
              icon="fa-regular fa-check-circle"
              color="green"
              size="1half-x"
          />
        </td>
        <td class="is-flex is-justify-content-start is-align-content-center">
          <span><strong>Acessos</strong></span>
        </td>
      </tr>
      <tr>
        <td>
          <font-awesome-icon
              :icon="integrationType === 'web' ? 'fa-regular fa-xmark-circle' : 'fa-regular fa-check-circle'"
              :color="integrationType === 'web' ? 'red' : 'green'"
              size="1half-x"
          />
        </td>
        <td class="is-flex is-justify-content-start is-align-content-center">
          <span><strong>Gestão de Pedidos</strong></span>
        </td>
      </tr>
      <tr>
        <td>
          <font-awesome-icon
              :icon="integrationType === 'web' ? 'fa-regular fa-xmark-circle' : 'fa-regular fa-check-circle'"
              :color="integrationType === 'web' ? 'red' : 'green'"
              size="1half-x"
          />
        </td>
        <td class="is-flex is-justify-content-start is-align-content-center">
          <span><strong>Integração ERP (sistema de gestão)</strong></span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {

  name: 'integrationFunctionsDiffTable',

  props: {
    integrationType: {
      required: true,
      type: String
    }
  }

}

</script>

<style>
.fa-1half-x {
  font-size: 1.5em;
}
</style>